import React, {useCallback, useEffect, useState} from 'react';
import cn from 'classnames';

import {useSlideToggle} from 'coreHooks';

import Button from 'brandComponents/Button';

import {AccordionProvider} from './AccordionContext';
import {IAccordionProps} from './IAccordion';
import {AccordionContent, AccordionHeader, AccordionHeaderIcon} from './Subcomponents';

import styles from './Accordion.module.scss';

const Accordion = ({
	titleContent,
	children,
	classNames,
	dataIds,
	expandIcon,
	collapseIcon,
	isOpen,
	onToggle,
	animated = true,
	scrollIntoView = false,
}: IAccordionProps) => {
	const {togglerRef, handleSlideToggle} = useSlideToggle<HTMLDivElement>(true, scrollIntoView);
	const [isOpenState, setIsOpenState] = useState(false);

	useEffect(() => {
		// sync isOpen state with props
		if (typeof isOpen !== 'undefined' && isOpen !== isOpenState) {
			setIsOpenState((prevState) => {
				if (animated) {
					handleSlideToggle(isOpen);
				}

				return !prevState;
			});
		}
	}, [isOpen]);

	const handleListOpen = useCallback(() => {
		setIsOpenState((prevState) => {
			if (animated) {
				handleSlideToggle(!prevState);
			}

			if (onToggle) {
				onToggle(!prevState);
			}

			return !prevState;
		});
	}, []);

	return (
		<AccordionProvider
			value={{
				togglerRef: animated ? togglerRef : null,
				handleListOpen,
				isOpen: isOpenState,
				expandIcon,
				collapseIcon,
			}}
		>
			<div className={cn(styles['accordion'], classNames.accordion, !animated && styles['accordion-no-animation'])}>
				<AccordionHeader classNames={cn(classNames.heading, styles['accordion__heading'])} dataIds={dataIds}>
					{titleContent}
					<div className={styles['accordion__btn__wrapper']}>
						<Button variant="tertiary">
							<AccordionHeaderIcon expandIcon="arrow-down" collapseIcon="arrow-up" width={16} height={16}/>
						</Button>
					</div>
				</AccordionHeader>

				<AccordionContent classNames={cn(classNames.content, styles['accordion__content'])}>
					{children}
				</AccordionContent>
			</div>

		</AccordionProvider>

	);
};

export default Accordion;
